import { PageHeaderWrapper } from '@ui';
import styled from 'styled-components';

export const EVisitsEditSC = styled(PageHeaderWrapper)`
  .e-visit-content {
    display: flex;
    height: calc(100vh - 301px);
    background-color: white;
    overflow: hidden;

    .modal-container {
      width: 100%;
      padding-right: 64px;

      .ui-textarea {
        width: 100%;
      }
    }
  }
`;
